exports = module.exports = require("../../../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.yandex-map-container[data-v-e17cc646] {\n  overflow: hidden;\n  transition: 0.8s;\n  max-height: 0;\n}\n.yandex-map-container--open[data-v-e17cc646] {\n    max-height: 400px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-e17cc646","scoped":true,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/sass-loader?{"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Techcenter/components/TcMap.vue
// module id = 803
// module chunks = 1